import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { TravelMapComponent } from "./components/TravelMapComponent";
import { JournalComponent } from "./components/Journal";
import { ModalPuzzelComponent } from "./components/ModalPuzzelComponent";
import { PuzzelComponent } from "./components/PuzzelComponent";
import { InventoryComponent } from "./components/Inventory";
import { AuthButtonComponent } from "./components/AuthButtonComponent";
import { LeaderboardComponent } from "./components/LeaderboardComponent";
import { LeaderboardButtonComponent } from "./components/LeaderboardButtonComponent";
import { ModalLeaderboardComponent } from "./components/ModalLeaderboardComponent";
import { ResultComponent } from "./components/ResultComponent";
import { LoginRegisterComponent } from "./components/LoginRegisterComponent";
import { UitlogMessageComponent } from "./components/UitlogMessage";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-puzzel", PuzzelComponent);
window.customElements.define("game-modal-puzzel", ModalPuzzelComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-travelmap", TravelMapComponent);
window.customElements.define("game-journal", JournalComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("auth-button", AuthButtonComponent); // Define the AuthButtonComponent
window.customElements.define("leaderboard-component", LeaderboardComponent);
window.customElements.define("leaderboard-component-modal", ModalLeaderboardComponent);
window.customElements.define("leaderboard-button", LeaderboardButtonComponent);
window.customElements.define("end-result", ResultComponent);
window.customElements.define("auth-component", LoginRegisterComponent);
window.customElements.define("uitlog-message", UitlogMessageComponent);
